import { LogLevelDesc } from "loglevel";
import { Reservation, Task } from "twilio-taskrouter";
import { CbmParticipant, CbmSdk, CbmSdkClientOptions, LogLevel } from "./dist";
import { LoggerOptions, getDefaultLoggerOptions } from "~/modules/logger";
import { SessionImpl } from "~/modules/session/Session/SessionImpl";
import type { Session } from "~/modules/session/Session/Session";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { getEnvironmentConfig } from "~/modules/config";
import { ClientOptionsStore } from "~/modules/client/ClientOptions/ClientOptionsStore";
import type { Cbm } from "~/packages/cbm/Cbm";

export class CbmImpl implements Cbm {
    readonly #loggerOptions: LoggerOptions;

    readonly #session: Session;

    readonly #clientOptions: ClientOptionsStore;

    #cbm: CbmSdk;

    constructor(ctx: ContextManager) {
        this.#loggerOptions = getDefaultLoggerOptions();
        this.#session = ctx.getInstanceOf(SessionImpl);
        this.#clientOptions = ctx.getInstanceOf(ClientOptionsStore);
    }

    async init(cbmInstance?: CbmSdk): Promise<void> {
        if (cbmInstance) {
            this.#cbm = cbmInstance;
            return Promise.resolve();
        }

        const environmentConfig = getEnvironmentConfig();
        const { region, regionNonFlex } = environmentConfig || {};
        const configRegion = regionNonFlex || this.#clientOptions.regionNonFlex || region || this.#clientOptions.region;

        const cbmOptions: CbmSdkClientOptions = {
            logLevel: this.mapToLogLevel(this.#clientOptions?.logger?.level)
        };

        if (configRegion !== undefined) {
            cbmOptions.region = configRegion;
        }

        this.#cbm = new CbmSdk(this.#session.token, cbmOptions);
        return Promise.resolve();
    }

    updateToken(token: string): void {
        this.#cbm.updateToken(token);
    }

    async acceptReservation(reservation: Reservation): Promise<Reservation> {
        

        
        return this.#cbm.acceptReservation(reservation);
    }

    async rejectReservation(reservation: Reservation): Promise<Reservation> {
        

        
        return this.#cbm.rejectReservation(reservation);
    }

    async getParticipantsByTask(task: Task): Promise<CbmParticipant[]> {
        const channels = await this.#cbm.getChannels(task);
        return this.#cbm.getParticipants(task, channels[0].sid);
    }

    completeReservation(reservation: Reservation): Promise<Reservation> {
        

        
        return this.#cbm.completeReservation(reservation);
    }

    wrapReservation(reservation: Reservation): Promise<Reservation> {
        

        
        return this.#cbm.wrapReservation(reservation);
    }

    private mapToLogLevel(logLevel: LogLevelDesc): LogLevel {
        if (typeof logLevel === "number") {
            switch (logLevel) {
                case 0:
                    return LogLevel.Trace;
                case 1:
                    return LogLevel.Debug;
                case 2:
                    return LogLevel.Info;
                case 3:
                    return LogLevel.Warn;
                case 4:
                    return LogLevel.Error;
                case 5:
                    return LogLevel.Silent;
                default:
                    return LogLevel.Warn;
            }
        } else if (typeof logLevel === "string") {
            const lowercaseLogLevel = logLevel.toLowerCase();
            if (lowercaseLogLevel in LogLevel) {
                return LogLevel[lowercaseLogLevel as keyof typeof LogLevel];
            }
        }
        return LogLevel.Warn;
    }
}
